import React from 'react';
import classnames from 'classnames';
import { LANGUAGE } from 'config/types/prop';
import Link from 'components/link';
import { sendEventToGA } from 'utils/googleAnalytics';
import componentStyles from './languagePicker.css';

const FlagLanguageItem = ({
  hasPlus,
  isCircle,
  flag,
  styles,
  text,
  url,
}) => (
  <Link
    className={classnames(
      styles.link,
      { [styles.plus]: hasPlus },
    )}
    to={url}
    onClick={() => (isCircle ? sendEventToGA('masthead_button') : sendEventToGA('flag_button'))}
  >
    <div
      className={classnames(
        componentStyles[flag],
        styles.flag,
        componentStyles.defaultStyles,
        { [componentStyles.circleFlag]: isCircle },
        { [styles.plus]: hasPlus },
      )}
      alt={
        'babbel' === flag ?
          'Icon for more languages' : `Flag for ${flag} language`
      }
    />
    <span>{text}</span>
  </Link>
);

FlagLanguageItem.propTypes = LANGUAGE;

FlagLanguageItem.defaultProps = {
  isCircle: false,
  hasPlus: false,
};

export default FlagLanguageItem;
